import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import styles from "./LanguageSwitcher.module.css";

export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, availableLanguages, isLoading } = useLanguage();

  const getLanguageLabel = (lang: string): string => {
    const labels: Record<string, string> = {
      en: "EN",
      de: "DE"
    };
    return labels[lang] || lang.toUpperCase();
  };

  const getLanguageName = (lang: string): string => {
    const names: Record<string, string> = {
      en: "English",
      de: "Deutsch"
    };
    return names[lang] || lang;
  };

  return (
    <div className={styles.languageSwitcher}>
      {availableLanguages.map((lang) => (
        <button
          key={lang}
          className={`${styles.languageButton} ${
            language === lang ? styles.active : ""
          } ${isLoading ? styles.disabled : ""}`}
          onClick={() => !isLoading && setLanguage(lang)}
          aria-label={`Switch to ${getLanguageName(lang)}`}
          disabled={isLoading}
        >
          {getLanguageLabel(lang)}
        </button>
      ))}
    </div>
  );
};
